export class GenralKeys {
    static googleMapApiKey = 'AIzaSyCoYcV0MKrxG7W-TlCfWOK5KUujhT3-tsM';
    // static googleMapApiKey = 'AIzaSyCFBamoTOfNAij2QdZz2G4EWTPVbqZiViM';
}